import { render, staticRenderFns } from "./attr-channel.vue?vue&type=template&id=54ef5771&scoped=true"
import script from "./attr-channel.vue?vue&type=script&lang=js"
export * from "./attr-channel.vue?vue&type=script&lang=js"
import style0 from "./attr-channel.vue?vue&type=style&index=0&id=54ef5771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef5771",
  null
  
)

export default component.exports